import { IAdUserData } from '@faire/web-api--source/faire/home_resource/IAdUserData';
import { IDatadogRUMConfig } from '@faire/web-api--source/faire/home_resource/IDatadogRUMConfig';
import { IHrefLang } from '@faire/web-api--source/faire/home_resource/IHrefLang';
import { IPreloadResource } from '@faire/web-api--source/faire/home_resource/IPreloadResource';
import { IReactRender } from '@faire/web-api--source/faire/home_resource/IReactRender';
import { IGetBrandLandingPageBrandDetailResponse } from '@faire/web-api--source/indigofair/brand/landing_page/IGetBrandLandingPageBrandDetailResponse';
import { IBrandReferralPromotion } from '@faire/web-api--source/indigofair/brand/referrals/IBrandReferralPromotion';
import { ICategoryProductImages } from '@faire/web-api--source/indigofair/category/ICategoryProductImages';
import { IPromotionalEventMilestone } from '@faire/web-api--source/indigofair/common/IPromotionalEventMilestone';
import { IAddressSchemaResponse } from '@faire/web-api--source/indigofair/data/IAddressSchemaResponse';
import { IAlertBanner } from '@faire/web-api--source/indigofair/data/IAlertBanner';
import { IApparelPreorderCategories } from '@faire/web-api--source/indigofair/data/IApparelPreorderCategories';
import { IAppDownloadIncentiveData } from '@faire/web-api--source/indigofair/data/IAppDownloadIncentiveData';
import { IAppPromotionBannerLinks } from '@faire/web-api--source/indigofair/data/IAppPromotionBannerLinks';
import { IBrand } from '@faire/web-api--source/indigofair/data/IBrand';
import { IBrandDiscountsResponse } from '@faire/web-api--source/indigofair/data/IBrandDiscountsResponse';
import { IBrandViewResponse } from '@faire/web-api--source/indigofair/data/IBrandViewResponse';
import { IBrandViewV2Response } from '@faire/web-api--source/indigofair/data/IBrandViewV2Response';
import { ICartSummaryResponse } from '@faire/web-api--source/indigofair/data/ICartSummaryResponse';
import { ICategory } from '@faire/web-api--source/indigofair/data/ICategory';
import { ICurrencyConversionRate } from '@faire/web-api--source/indigofair/data/ICurrencyConversionRate';
import { ICurrentPromotionalEventResponse } from '@faire/web-api--source/indigofair/data/ICurrentPromotionalEventResponse';
import { IFaireMoney } from '@faire/web-api--source/indigofair/data/IFaireMoney';
import { IFDMarketplaceDiscountData } from '@faire/web-api--source/indigofair/data/IFDMarketplaceDiscountData';
import { IFeaturedSeasonalTile } from '@faire/web-api--source/indigofair/data/IFeaturedSeasonalTile';
import { IFirstOrderIncentiveDiscountData } from '@faire/web-api--source/indigofair/data/IFirstOrderIncentiveDiscountData';
import { IFreeShippingStatusResponse } from '@faire/web-api--source/indigofair/data/IFreeShippingStatusResponse';
import { IGetBrandTopCategoryResponse } from '@faire/web-api--source/indigofair/data/IGetBrandTopCategoryResponse';
import { IGetRetailerBoardLeanBrandTilesPaginationResponse } from '@faire/web-api--source/indigofair/data/IGetRetailerBoardLeanBrandTilesPaginationResponse';
import { IGetRetailerBoardResponse } from '@faire/web-api--source/indigofair/data/IGetRetailerBoardResponse';
import { IMembership } from '@faire/web-api--source/indigofair/data/IMembership';
import { INetTermBlocker } from '@faire/web-api--source/indigofair/data/INetTermBlocker';
import { INextOrderIncentiveDiscountData } from '@faire/web-api--source/indigofair/data/INextOrderIncentiveDiscountData';
import { INudgeToCheckoutResponse } from '@faire/web-api--source/indigofair/data/INudgeToCheckoutResponse';
import { IOpenGraphMetadata } from '@faire/web-api--source/indigofair/data/IOpenGraphMetadata';
import { IOpeningOrderDiscountData } from '@faire/web-api--source/indigofair/data/IOpeningOrderDiscountData';
import { IPaymentDisputeModalData } from '@faire/web-api--source/indigofair/data/IPaymentDisputeModalData';
import { IProductFirstCatNavWithLeanProductTileResponse } from '@faire/web-api--source/indigofair/data/IProductFirstCatNavWithLeanProductTileResponse';
import { IProductPageResponse } from '@faire/web-api--source/indigofair/data/IProductPageResponse';
import { IPromoModalInformationResponse } from '@faire/web-api--source/indigofair/data/IPromoModalInformationResponse';
import { IQueryProductsV2WithLeanTileResponse } from '@faire/web-api--source/indigofair/data/IQueryProductsV2WithLeanTileResponse';
import { IReEngagementIncentiveData } from '@faire/web-api--source/indigofair/data/IReEngagementIncentiveData';
import { IRetailer } from '@faire/web-api--source/indigofair/data/IRetailer';
import { ISearchBrandLeanProductTilesResponse } from '@faire/web-api--source/indigofair/data/ISearchBrandLeanProductTilesResponse';
import { ISimilarBrandsResponse } from '@faire/web-api--source/indigofair/data/ISimilarBrandsResponse';
import { IStyleQuiz } from '@faire/web-api--source/indigofair/data/IStyleQuiz';
import { IUser } from '@faire/web-api--source/indigofair/data/IUser';
import { IUserMilestone } from '@faire/web-api--source/indigofair/data/IUserMilestone';
import { IInsiderMembershipInformation } from '@faire/web-api--source/indigofair/insider/IInsiderMembershipInformation';
import { IRetailerShippingSavings } from '@faire/web-api--source/indigofair/insider/IRetailerShippingSavings';
import { ILocaleKey } from '@faire/web-api--source/indigofair/locale/ILocaleKey';
import { IRetailerUserNotificationCount } from '@faire/web-api--source/indigofair/retailer/IRetailerUserNotificationCount';
import { ISeoCategoryText } from '@faire/web-api--source/indigofair/seo/ISeoCategoryText';

export namespace IRetailerPageData {
  export namespace IPrefetchedData {
    export namespace ILoggedOutBrandPage {
      /**
       * Return an instance of ILoggedOutBrandPage with the provided fields. Any field not
       * listed will be populated with an empty value (an empty array,
       * or undefined, whichever is valid for the type of the value.)
       */
      export const build = (
        partial?: Partial<ILoggedOutBrandPage>
      ): ILoggedOutBrandPage =>
        ({
          ...(partial ?? {}),
        }) as ILoggedOutBrandPage;
    }

    export interface ILoggedOutBrandPage {
      brand_view: IBrandViewResponse | undefined;
      brand_products: ISearchBrandLeanProductTilesResponse | undefined;
      similar_brands: ISimilarBrandsResponse | undefined;
      top_category: IGetBrandTopCategoryResponse | undefined;
    }

    /**
     * Return an instance of IPrefetchedData with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<IPrefetchedData>
    ): IPrefetchedData =>
      ({
        ...(partial ?? {}),
      }) as IPrefetchedData;
  }

  export interface IPrefetchedData {
    category_page_products:
      | IProductFirstCatNavWithLeanProductTileResponse
      | undefined;
    logged_out_brand_page:
      | IRetailerPageData.IPrefetchedData.ILoggedOutBrandPage
      | undefined;
    /**
     * Prefetched brand that a retailer is looking at, as opposed to RetailerPageData#brand, which is
     * the authenticated user session brand.
     */
    brand: IBrand | undefined;
    brand_view: IBrandViewResponse | undefined;
    product_page: IProductPageResponse | undefined;
    event_board: IGetRetailerBoardResponse | undefined;
    event_board_items:
      | IGetRetailerBoardLeanBrandTilesPaginationResponse
      | undefined;
    brand_view_v2: IBrandViewV2Response | undefined;
    /**
     * @deprecated
     */
    search_page_products: IQueryProductsV2WithLeanTileResponse | undefined;
    /**
     * Leaf category of category(s) matching for a /category/:categoryName routes
     */
    active_category: ICategory | undefined;
    brand_landing_page_detail:
      | IGetBrandLandingPageBrandDetailResponse
      | undefined;
  }

  export namespace IModalData {
    /**
     * Return an instance of IModalData with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (partial?: Partial<IModalData>): IModalData =>
      ({
        ...(partial ?? {}),
      }) as IModalData;
  }

  export interface IModalData {
    /**
     * for PAYMENT_PLAN_PAYMENT_FAILED_MODAL
     */
    defaulted_payment_plan_token: string | undefined;
    /**
     * for PAYMENT_PLAN_FULLY_PAID_MODAL
     */
    fully_paid_payment_plan_amount: IFaireMoney | undefined;
    /**
     * for OVERDUE_INVOICE_MODAL
     */
    overdue_invoices_count: number | undefined;
  }

  export namespace ISmallBusinessGrantDates {
    /**
     * Return an instance of ISmallBusinessGrantDates with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    export const build = (
      partial?: Partial<ISmallBusinessGrantDates>
    ): ISmallBusinessGrantDates =>
      ({
        ...(partial ?? {}),
      }) as ISmallBusinessGrantDates;
  }

  export interface ISmallBusinessGrantDates {
    due_date: string | undefined;
    review_date_range: string | undefined;
    announcement_date: string | undefined;
  }

  /**
   * Return an instance of IRetailerPageData with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (
    partial?: Partial<IRetailerPageData>
  ): IRetailerPageData =>
    ({
      user_milestones: [],
      referral_promotions: [],
      referral_bonus_offer_referral_names: [],
      known_referrer_adoption_brand_names: [],
      categories: [],
      featured_seasonal_tiles: [],
      free_shipping_statuses: [],
      available_memberships: [],
      preload_urls: [],
      preload_resources: [],
      suggested_search_terms: [],
      href_langs: [],
      available_language_selector_locales: [],
      promotional_event_milestones: [],
      ...(partial ?? {}),
    }) as IRetailerPageData;
}

/**
 * @protobufOption (faire.home_resource.resourceType) = RETAILER
 */
export interface IRetailerPageData {
  /**
   * environment set up
   */
  env_name: string | undefined;
  /**
   * Base URL for the CDN (including a trailing slash).
   */
  cdn_url: string | undefined;
  ad_user_data: IAdUserData | undefined;
  og_meta_data: IOpenGraphMetadata | undefined;
  facebook_open_graph_image_url: string | undefined;
  /**
   * @deprecated
   */
  no_index_meta_tag: boolean | undefined;
  robots_meta_tag: string | undefined;
  is_robot: boolean | undefined;
  is_prerender: boolean | undefined;
  is_url_recognized: boolean | undefined;
  /**
   * Type of SSR to perform, if any.
   */
  server_side_render: keyof typeof IReactRender.ServerSideRender | undefined;
  /**
   * Explicit renderer to use. Defaults to global settings if not specified.
   */
  react_renderer: keyof typeof IReactRender.Renderer | undefined;
  /**
   * Original URL of the HTTP request.
   */
  original_url: string | undefined;
  /**
   * canonical url setup
   */
  server_side_canonicalization: boolean | undefined;
  canonical_u_r_l: string | undefined;
  /**
   * Templated path of the endpoint. For example, "/api/{token}".
   */
  templated_path: string | undefined;
  /**
   * Deprecated - Meta tags are now fetched from /api/seo/category-meta-tags
   * @deprecated
   */
  seo_category_text: ISeoCategoryText | undefined;
  /**
   * meta text setup
   */
  meta_description: string | undefined;
  meta_keywords: string | undefined;
  /**
   * tracking (needed on every page)
   */
  facebook_retailer_pixel_id: string | undefined;
  facebook_maker_pixel_id: string | undefined;
  facebook_optimization_test_pixel_id: string | undefined;
  twitter_pixel_id: string | undefined;
  google_tracking_id: string | undefined;
  serve_heap_analytics: boolean | undefined;
  google_tag_manager_container_id: string | undefined;
  sentry_id: string | undefined;
  cookie_consent_key: string | undefined;
  /**
   * Google SSO
   */
  google_sso_enabled: boolean | undefined;
  google_sso_client_id: string | undefined;
  /**
   * can be different based on url. ie. /admin /admin2 vs everywhere else
   */
  release_version: string | undefined;
  release_sha: string | undefined;
  /**
   * Short hash of the version of the JS script.
   */
  js_version: string | undefined;
  js_integrity: string | undefined;
  /**
   * Whether to emit the integrity="{{jsIntegrity}}" attribute to the script tag.
   */
  enable_js_integrity: boolean | undefined;
  css_version: string | undefined;
  /**
   * Locale component of the JS build, if applicable. e.g. "es".
   * This changes the filename of the fetched script to be retailer.{jsVersion}.{jsLocale}.js.
   */
  js_locale: string | undefined;
  /**
   * settings
   */
  load_only_visible_images: boolean | undefined;
  /**
   * @deprecated
   */
  show_experimental_home_page_design: boolean | undefined;
  maker_count: number | undefined;
  /**
   * @deprecated
   */
  new_brands_count: number | undefined;
  new_brands_this_week_count: number | undefined;
  /**
   * app promotion banner
   * @deprecated
   */
  should_show_app_banner_mobile: boolean | undefined;
  app_promotion_banner_links: IAppPromotionBannerLinks | undefined;
  is_app_installed: boolean | undefined;
  show_amex_banner: boolean | undefined;
  /**
   * @deprecated
   */
  first_order_free_shipping_offer_expires_at: number | undefined;
  has_placed_first_app_order: boolean | undefined;
  /**
   * Incentives
   */
  opening_order_discount_data: IOpeningOrderDiscountData | undefined;
  /**
   * @deprecated
   */
  first_order_incentive_discount_data:
    | IFirstOrderIncentiveDiscountData
    | undefined;
  app_download_incentive_data: IAppDownloadIncentiveData | undefined;
  /**
   * @deprecated
   */
  re_engagement_incentive_data: IReEngagementIncentiveData | undefined;
  fd_marketplace_discount_data: IFDMarketplaceDiscountData | undefined;
  next_order_incentive_discount_data:
    | INextOrderIncentiveDiscountData
    | undefined;
  /**
   * useful user data
   */
  user_token: string | undefined;
  user: IUser | undefined;
  user_milestones: Array<IUserMilestone>;
  session_country: string | undefined;
  currency_conversion_rate: ICurrencyConversionRate | undefined;
  currency_format_locale: string | undefined;
  retailer_user_notification_count: IRetailerUserNotificationCount | undefined;
  /**
   * useful retailer data
   * @protobufOption (.faire.common.tokenType) = RETAILER
   */
  retailer_token: string | undefined;
  retailer: IRetailer | undefined;
  /**
   * @deprecated
   */
  style_quiz: IStyleQuiz | undefined;
  store_type: string | undefined;
  is_verified_retailer: boolean | undefined;
  is_apparel_retailer: boolean | undefined;
  is_upmarket_retailer: boolean | undefined;
  is_engaged_upmarket_retailer: boolean | undefined;
  /**
   * @deprecated
   */
  current_net_terms_blocker: INetTermBlocker | undefined;
  /**
   * @deprecated
   */
  is_eligible_for_apparel_exclusive_sale: boolean | undefined;
  nudge_to_checkout: INudgeToCheckoutResponse | undefined;
  referral_promotions: Array<IBrandReferralPromotion>;
  /**
   * @deprecated
   */
  referral_bonus_offer_referral_names: Array<string>;
  /**
   * @deprecated
   */
  known_referrer_adoption_brand_names: Array<string>;
  /**
   * useful brand data
   * @protobufOption (.faire.common.tokenType) = BRAND
   */
  brand_token: string | undefined;
  /**
   * @protobufOption (.faire.common.tokenType) = BRAND
   */
  editing_as_brand_token: string | undefined;
  /**
   * the authenticated user session brand.
   */
  brand: IBrand | undefined;
  /**
   * -1 no walkthrough, 0 = complete or about to expire
   */
  walkthrough_time_remaining_millis: number | undefined;
  /**
   * plaid data
   */
  plaid_env: string | undefined;
  plaid_key: string | undefined;
  plaid_webhook_url: string | undefined;
  /**
   * square connect,
   * @deprecated
   */
  square_connection_application_id: string | undefined;
  /**
   * @deprecated
   */
  square_connection_location_id: string | undefined;
  /**
   * external providers
   */
  stripe_public_key: string | undefined;
  shopify_access_url: string | undefined;
  google_places_api_key: string | undefined;
  full_story_id: string | undefined;
  /**
   * specific to the ind page
   */
  elevate_brand_token: string | undefined;
  faire_direct_brand_alias: string | undefined;
  /**
   * @deprecated
   */
  session_access_token: string | undefined;
  cdn_name: string | undefined;
  /**
   * Deprecated - categories are prefetched via /api/v3/categories endpoints
   * @deprecated
   */
  categories: Array<ICategory>;
  /**
   * Deprecated - uses subcategory product images elsewhere
   * @deprecated
   */
  category_product_images: ICategoryProductImages | undefined;
  /**
   * Deprecated - data is merged into categories (tag 82 above)
   * @deprecated
   */
  featured_seasonal_tiles: Array<IFeaturedSeasonalTile>;
  free_shipping_statuses: Array<IFreeShippingStatusResponse.IFreeShippingStatus>;
  promo_modal_information: IPromoModalInformationResponse | undefined;
  available_memberships: Array<IMembership>;
  brand_discounts: IBrandDiscountsResponse | undefined;
  cart_summary: ICartSummaryResponse | undefined;
  cart_token: string | undefined;
  has_memberships: boolean | undefined;
  insider_membership: IMembership | undefined;
  insider_membership_information: IInsiderMembershipInformation | undefined;
  is_frontend_override: boolean | undefined;
  has_referrals_r2_m: boolean | undefined;
  /**
   * specific to the static page
   */
  show_value_props_copy_changes20181121: boolean | undefined;
  show_free_freight_banner: boolean | undefined;
  /**
   * static page AB tests
   */
  default_payment_term_net90: boolean | undefined;
  /**
   * js/css bundle prefix
   */
  bundle_prefix: string | undefined;
  insider_shipping_savings: IRetailerShippingSavings | undefined;
  is_locally_hosted_frontend: boolean | undefined;
  datadog_rum_config: IDatadogRUMConfig | undefined;
  builder_i_o_api_key: string | undefined;
  /**
   * JSONified string of the map of setting/value pairs marked for serialization to RETAILER / LOGGED_IN_RETAILER
   */
  settings_values: string | undefined;
  /**
   * JSONified string of the map of setting/value pairs marked for serialization to HOTJAR_RETAILER
   */
  hotjar_settings_values: string | undefined;
  /**
   * JSONified string of the map of setting/value pairs, for all settings that the user has been assigned a value
   */
  performance_metric_settings: string | undefined;
  /**
   * String of the settings memento as a JWT. This should be sent along with all requests to a backend service.
   */
  settings_memento: string | undefined;
  /**
   * @deprecated
   */
  net_terms_blocker_experiment: boolean | undefined;
  alert_banner: IAlertBanner | undefined;
  external_sales_rep_name: string | undefined;
  vendor_bundle_url: string | undefined;
  vendors_retailer_bundle_url: string | undefined;
  /**
   * URLs of JS resources to preload.
   * Deprecated: Use preloadResources instead.
   * @deprecated
   */
  preload_urls: Array<string>;
  /**
   * URLs of resources to preload. Typically used for JS scripts, and Faire APIs we know we'll be loading.
   */
  preload_resources: Array<IPreloadResource>;
  address_schema_map: IAddressSchemaResponse | undefined;
  /**
   * @deprecated
   */
  faire_winter_market_live_stream_active: boolean | undefined;
  /**
   * @deprecated
   */
  apparel_preorder_categories: IApparelPreorderCategories | undefined;
  suggested_search_terms: Array<string>;
  locale_key: ILocaleKey | undefined;
  /**
   * This is the locale formatted as ll or ll_CC, such as en, en_CA, or fr_FR
   */
  locale_id: string | undefined;
  /**
   * Alternate localized URLs to emit <link rel="alternate"> tags for
   */
  href_langs: Array<IHrefLang>;
  available_language_selector_locales: Array<ILocaleKey>;
  /**
   * Initial (landing-page) Route attribution
   */
  route_product_area: string | undefined;
  route_pod: string | undefined;
  route_pillar: string | undefined;
  prefetched_data: IRetailerPageData.IPrefetchedData | undefined;
  is_brand_in_sign_up_flow_experiment: boolean | undefined;
  serialize_is_brand_in_sign_up_flow_experiment: boolean | undefined;
  apple_sso_client_id: string | undefined;
  /**
   * @deprecated
   */
  is_fashion_week_non_apparel_retailer: boolean | undefined;
  navigation_tree_hash_code: string | undefined;
  /**
   * Only supports 4-letter prefix for now, e.g. "en-gb" in www.faire.com/en-gb/
   */
  locale_country_url_prefix: string | undefined;
  trustpilot_rating: number | undefined;
  /**
   * Whether to record PETE events for the page lifecycle from the client.
   */
  record_lifecycle_events: boolean | undefined;
  /**
   * Localized URL for sitelink search box script
   */
  sitelink_search_box_url: string | undefined;
  /**
   * Full product schema for product pages
   */
  product_schema: string | undefined;
  /**
   * Full product schema for product pages
   */
  shipping_policy_schemas: string | undefined;
  /**
   * Full product schema for product pages
   */
  return_policy_schema: string | undefined;
  /**
   * Full collection page schema for category, attribute, brand value, explore, and discover pages
   */
  collection_page_schema: string | undefined;
  /**
   * Wholesale store schema surfaced on brand page
   */
  brand_page_schema: string | undefined;
  /**
   * SEO schema for Faire Academy pages
   */
  faire_academy_page_schema: string | undefined;
  /**
   * Schema for Breadcrumb list
   */
  breadcrumb_list_schema: string | undefined;
  /**
   * Reduce critical early bandwidth spent on fonts.
   */
  reduce_preloaded_fonts: boolean | undefined;
  next_or_active_promotional_event:
    | ICurrentPromotionalEventResponse
    | undefined;
  /**
   * Used by FE to determine whether to fallback to discover page layout or explore page new design
   *  New design: https://www.figma.com/file/Qz0NDlHgvUMIckhIjNXE30/Explore-Pages-Design-(v2)?node-id=545%3A37067
   * @deprecated
   */
  has_explore_page_terms: boolean | undefined;
  /**
   * Legacy toggle to control using woff2 fonts instead of otf.
   * @deprecated
   */
  use_woff: boolean | undefined;
  /**
   * User-Agent header value
   */
  user_agent: string | undefined;
  payment_dispute_modal_data: IPaymentDisputeModalData | undefined;
  /**
   * discountBps for current promotional market event
   */
  market_event_matched_discount_bps: number | undefined;
  /**
   * freeShippingDiscountMatch for current promotional market event
   */
  market_event_free_shipping_matched_discount_bps: number | undefined;
  /**
   * Promotional Event Milestones
   */
  promotional_event_milestones: Array<IPromotionalEventMilestone>;
  account_user_token: string | undefined;
  modal_data: IRetailerPageData.IModalData | undefined;
  owf_referral_code: string | undefined;
  owf_referral_code_v2: string | undefined;
  /**
   * Use HTTP client (POST request) instead of gRPC to communicate with web-retailer-server.
   */
  use_http_client: boolean | undefined;
  /**
   * Stream the response from the server to the client via gRPC. Also applies to HTTP if useHttpClient is true.
   */
  stream_response: boolean | undefined;
  small_business_grant_dates:
    | IRetailerPageData.ISmallBusinessGrantDates
    | undefined;
}
